export default __webpack_public_path__ + "static/media/small_delete.90cfe87d.svg";